# GraphQL mutation to reposition a step template within a new/current stage

#import "../fragments/sales-automation-step-template.graphql"

mutation RepositionStepTemplate($stepTemplatePositionPayload: RepositionStepTemplateInput!) {
    repositionStepTemplate(input: $stepTemplatePositionPayload) {
        stepTemplate {
            ...SalesAutomationStepTemplate
        }
        oldStage {
            id
            editableStepTemplates {
                ...SalesAutomationStepTemplate
            }
        }
        newStage {
            id
            editableStepTemplates {
                ...SalesAutomationStepTemplate
            }
        }
    }
}
